"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalInsuranceType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var MedicalInsuranceType_Factory = /** @class */ (function () {
    function MedicalInsuranceType_Factory() {
    }
    MedicalInsuranceType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            MedicalInsuranceTypeCode: model.MedicalInsuranceTypeCode,
        };
        return result;
    };
    MedicalInsuranceType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Description: model.Description,
            MedicalInsuranceTypeCode: model.MedicalInsuranceTypeCode,
        };
        return result;
    };
    return MedicalInsuranceType_Factory;
}());
exports.MedicalInsuranceType_Factory = MedicalInsuranceType_Factory;
